const messages = {

    en: {
        translations: {

            navbar: {
                privateContact: 'PARTICULAR CONTACT',
                home: 'Home',
                about: 'About',
                skills: 'Skills',
                projects: 'Projects',
                contact: 'Contact'
            },

            initial: {
                wellcome: "Welcome, I'm",
                h1: 'Gabriel Gonçalves Cunha',
                h2: 'Developer',
                em: 'front end.',
                p: 'Creating efficient and optimized interfaces'
            },

            presentation: {
                about: 'ABOUT',
                about_text1: 'I am willing to make whatever is in my hands work to the best of my ability.',
                address: 'LIVE ON',
                address_text1: 'São Paulo',
                address_text2: 'São Paulo',
                address_text3: 'Brazil',
                experience: 'EXPERIENCE',
                experience_text: '2 - 5 years | Pleno (mid)',
                download: 'DOWNLOAD',
                download_button: 'Profile.pdf'
            },

            skills: {
                focus: 'Focus & Skills',
                p: 'My focus is on delivering results. My main areas of expertise include: Developing responsive and fast websites with professional design. Creating e-commerces optimized for conversion. Developing strategic landing pages for campaigns and launches. SEO optimization to increase visibility on Google. Specialized website maintenance and technical support.',

                development_desc: 'Development of modern and fast applications, using reusable components to ensure scalability.',
                design_desc: 'Creating intuitive and professional interfaces, focused on user experience and visual fidelity.',
                marketing_desc: 'Google optimization (SEO) and cloud infrastructure to ensure the site handles high traffic and loads instantly.',
                workflow_desc: 'Using organized workflows and version control to ensure code security and consistent deliveries.'
            },

            projects: {
                project: 'PROJECTS',
                development: 'Developments and participations',
                seemore: 'View more',
                modal_button: 'Close',
                modal_warning: 'The site may not be available due to client administration. Updated on 2022-07-04*',
                modal_warning2: 'The site may not be available due to client administration. Updated on 2025-12-18*',
                text_dev:'In these projects, I was responsible for the frontend development of over 45 stores, working together with the team ',
            },

            contact: {
                send: 'Send an email to',
                follow: 'FOLLOW'
            }
        }
    }
}

export { messages }

//   {i18n.t('quote.info')}
//   import { i18n } from "../../translate/i18n";